import { Professional } from "../models/Professional";
import { clean } from "../utils/utils";
import api from "./api"; // the custom Axios instance
import { Invitation } from "../models/Invitation";
import { Matter } from "../models/Matter";

const PATH = "/api/v1/professionals";

export const ProfessionalService = {
  async createProfessional(
    file: globalThis.File | null,
    professionalData: Omit<
      Professional,
      "_id" | "createdAt" | "updatedAt" | "createdById" | "updatedById" | "name"
    >,
  ): Promise<string> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    if (professionalData.firstName)
      formData.append("firstName", professionalData.firstName);
    if (professionalData.lastName)
      formData.append("lastName", professionalData.lastName);
    if (professionalData.email)
      formData.append("email", professionalData.email);
    if (professionalData.phoneNumber)
      formData.append("phoneNumber", professionalData.phoneNumber);
    if (professionalData.roles)
      formData.append("roles", professionalData.roles.join(","));
    if (professionalData.websiteUrl)
      formData.append("websiteUrl", professionalData.websiteUrl);
    if (professionalData.schedulingUrl)
      formData.append("schedulingUrl", professionalData.schedulingUrl);
    if (professionalData.bio) formData.append("bio", professionalData.bio);
    if (professionalData.city) formData.append("city", professionalData.city);
    if (professionalData.state)
      formData.append("state", professionalData.state);
    if (professionalData.licensedStates)
      formData.append(
        "licensedStates",
        professionalData.licensedStates.join(","),
      );

    const response = await api.post(PATH, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.data._id;
  },

  async getProfessional(professionalId: string): Promise<Professional> {
    const response = await api.get(`${PATH}/${professionalId}`);
    return response.data.data;
  },

  async getAll(): Promise<Professional[]> {
    const response = await api.get(PATH);
    return response.data.data;
  },

  async updateProfessional(
    professionalId: string,
    file: globalThis.File | null,
    updatedData: Partial<Omit<Professional, "_id" | "createdAt">>,
  ): Promise<void> {
    const formData = new FormData();
    if (file) formData.append("file", file);
    if (updatedData.firstName)
      formData.append("firstName", updatedData.firstName);
    if (updatedData.lastName) formData.append("lastName", updatedData.lastName);
    if (updatedData.email) formData.append("email", updatedData.email);
    if (updatedData.phoneNumber)
      formData.append("phoneNumber", updatedData.phoneNumber);
    if (updatedData.roles)
      formData.append("roles", updatedData.roles.join(","));
    if (updatedData.websiteUrl)
      formData.append("websiteUrl", updatedData.websiteUrl);
    if (updatedData.schedulingUrl)
      formData.append("schedulingUrl", updatedData.schedulingUrl);
    if (updatedData.bio) formData.append("bio", updatedData.bio);
    if (updatedData.city) formData.append("city", updatedData.city);
    if (updatedData.state) formData.append("state", updatedData.state);
    if (updatedData.licensedStates)
      formData.append("licensedStates", updatedData.licensedStates.join(","));

    await api.patch(`${PATH}/${professionalId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async deleteProfessional(professionalId: string): Promise<void> {
    await api.delete(`${PATH}/${professionalId}`);
  },

  async createInvitation(
    professionalId: string,
    date: { message: string; matterId: Matter["_id"] } | Invitation,
  ): Promise<void> {
    await api.post(`${PATH}/${professionalId}/invitations`, clean(date));
  },
};
